<div class="content1">
  <div class="step-row">
    <div class="step"></div>
    <div class="step on"></div>
  </div>

  <!-- {{ curPage }} -->
  <div [ngSwitch]="curPage">
    <!-- User requests password reset by entering their email  -->
    <div *ngSwitchCase="curPageEnum.RESET_PASSWORD_GET_EMAIL">
      <div>
        <h1 class="page-title">Reset Password</h1>
        <p class="page-sub">Please enter the verification code sent to your email address.</p>
      </div>

      <form class="glass" [formGroup]="emailFormGroup" (ngSubmit)="sendCode()">
        <mat-form-field class="form-field" appearance="fill">
          <mat-label>Email</mat-label>
          <input id="email" type="email" autocomplete="off" matInput formControlName="email"/>
          <mat-error *ngIf="emailFormGroup.get('email')?.getError('required')">Email is required</mat-error>
          <mat-error *ngIf="emailFormGroup.get('email')?.getError('email')">Invalid email format</mat-error>
        </mat-form-field>

        <div class="row justify-content-end">
          <div class="text-center">
            <button mat-raised-button type="submit" [disabled]="emailFormGroup.invalid" color="primary">Send Code</button>
          </div>
        </div>
      </form>
    </div>

    <!-- User enters the code they received via email to move onto the NEW PASSWORD process -->
    <div *ngSwitchCase="curPageEnum.CODE">
      <div>
        <h1 class="page-title">Reset Password</h1>
        <p class="page-sub">Please enter the verification code sent to your email address.</p>
      </div>

      <form class="glass">      

        <p class="mb-4" *ngIf="resetAction == resetActionEnum.NEW_PASSWORD_REQUIRED">
          A password reset and email verification is required. Please enter the verification code sent to your email to proceed with setting a new password.
        </p>

        <app-code-input 
          title="" 
          [loading]="false" 
          [backTitle]="'Resend Verification Code'"
          [nextTitle]="'Verify Code'"
          (onReset)="sendCode()"
          (onNext)="confirmEmailCode($event)">
          <span>
            We sent a code via email to <span style="color: dodgerblue;">{{ emailFormGroup.get('email')?.value?.trim() }}</span>, please enter the code above to verify your email.
            <b>You will then be asked to set a new password!</b>
          </span>
        </app-code-input>
      </form>
    </div>

    <!-- This is a different process, a user is forced to reset their password, after they have logged in  -->
    <div *ngSwitchCase="curPageEnum.NEW_PASSOWORD">
      <div>
        <h1 class="page-title">Set New Password</h1>
        <p class="page-sub">Please enter your new password below.</p>
      </div>

      <div class="row justify-content-center auth-container mt-4">
        <form class="glass" autocomplete="off" [formGroup]="passwordResetFormGroup" (ngSubmit)="setNewPassword()">
          <mat-form-field class="form-field mb-3" appearance="fill">
            <mat-label>New Password</mat-label>
            <input id="password" matInput formControlName="password" autocomplete="new-password" 
            [type]="showPassword ? 'text' : 'password'"/>
            <mat-icon matSuffix class="pointer"
                      [title]="showPassword ? 'Hide Password' : 'Show Password'"
                      (click)="showPassword = !showPassword">
              {{showPassword ? 'visibility_off' : 'visibility'}}
            </mat-icon>
            <mat-hint align="end">Password must contain lowercase, uppercase, numbers, special characters, and be at least 8 characters</mat-hint>
            <mat-error *ngIf="passwordResetFormGroup.get('password')?.getError('required')">Password is required</mat-error>
            <mat-error *ngIf="passwordResetFormGroup.get('password')?.getError('pattern')">
              Password must contain lowercase, uppercase, numbers, special characters, and be at least 8 characters
            </mat-error>
          </mat-form-field>
          <div class="justify-content-end">
            <button mat-raised-button type="submit" [disabled]="passwordResetFormGroup.invalid" color="primary">Set New Password</button>
          </div>
        </form>
      </div>
    </div>


    
    <!-- User enters their new password to complete the reset -->
    <div *ngSwitchCase="curPageEnum.NEW_PASSWORD_AFTER_CHALLENGE">
      <div>
        <h1 class="page-title">Set New Password</h1>
        <p class="page-sub">You are now setting your <b>new password</b>, after having entered your temporary password which had been provided to you via email.</p>
      </div>
      <form class="glass" autocomplete="off" [formGroup]="passwordResetFormGroup" (ngSubmit)="setNewPasswordAfterChallenge()">
        <mat-form-field class="form-field mb-3" appearance="fill">
          <mat-label>New Password</mat-label>
          <input id="password" matInput formControlName="password" autocomplete="new-password" [type]="showPassword ? 'text' : 'password'"/>
          <mat-icon matSuffix class="pointer"
                    [title]="showPassword ? 'Hide Password' : 'Show Password'"
                    (click)="showPassword = !showPassword">
            {{showPassword ? 'visibility_off' : 'visibility'}}
          </mat-icon>
          <mat-hint align="end">Password must contain lowercase, uppercase, numbers, special characters, and be at least 8 characters</mat-hint>
          <mat-error *ngIf="passwordResetFormGroup.get('password')?.getError('required')">Password is required</mat-error>
          <mat-error *ngIf="passwordResetFormGroup.get('password')?.getError('pattern')">
            Password must contain lowercase, uppercase, numbers, special characters, and be at least 8 characters
          </mat-error>
        </mat-form-field>

        <div class="justify-content-end">
          <button mat-raised-button type="submit" [disabled]="passwordResetFormGroup.invalid" color="primary">Set New Password</button>
        </div>
      </form>
    </div>
  </div>

</div>


<div class="row pt-4">
  <div id="last" class="page-sub text-center">
    <a class="link" [routerLink]="authService.LOGIN_ROUTE">Sign In</a> / <a class="link" [routerLink]="authService.REGISTER_ROUTE">Register</a>
  </div>
</div>

